import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/guru-education";
var post = "/guru-education";
export const actGetDataHistoryEduGuru = (id = "", filter = "teacher") => {
  return (dispatch) => {
    let config = CONFIG_({
      url: get + "/" + id + "?filter=" + filter,
      method: "GET",
    });
    dispatch({ type: "LOADING_HISTORYEDUGURU_GURU" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200 || data.length >= 0) {
          return dispatch({
            type: "SUCCESS_HISTORYEDUGURU_GURU",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({
          type: "ERROR_HISTORYEDUGURU_GURU",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_HISTORYEDUGURU_GURU",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataHistoryEduGuru = (params) => {
  return (dispatch) => {
    const { guru } = params;
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_HISTORYEDUGURU_GURU" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("History education has been create");
          dispatch(
            __openModal({ modal: "MODAL_ADD_HISTORYEDUGURU", open: false })
          );
          return dispatch(actGetDataHistoryEduGuru(guru));
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_HISTORYEDUGURU_GURU",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_HISTORYEDUGURU_GURU",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataHistoryEduGuru = (params) => {
  return (dispatch) => {
    const { id, guru } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_HISTORYEDUGURU_GURU" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("History education has been update");
          dispatch(
            __openModal({ modal: "MODUL_EDIT_HISTORYEDUGURU", open: false })
          );
          return dispatch(actGetDataHistoryEduGuru(guru));
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_HISTORYEDUGURU_GURU",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_HISTORYEDUGURU_GURU",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataHistoryEduGuru = (params) => {
  return (dispatch) => {
    const { id, guru } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_HISTORYEDUGURU_GURU" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Data has been deleted");
          return dispatch(actGetDataHistoryEduGuru(guru));
        }
        return dispatch({
          type: "ERROR_HISTORYEDUGURU_GURU",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_HISTORYEDUGURU_GURU",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataHistoryEduGuru = (params) => {
  return (dispatch) => {
    const { id, guru } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_HISTORYEDUGURU_GURU" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("History education has been delete");
          return dispatch(actGetDataHistoryEduGuru(guru));
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_HISTORYEDUGURU_GURU",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_HISTORYEDUGURU_GURU",
          message: "Network error..",
        });
      });
  };
};
